import { SignatureStatus } from '../../constants/signature-status';

export interface SignatureModifiedState {
  signatureId: string;
  isLocked: boolean;
  lastUpdated: Date;
  signerType: string;
  signerVerified: boolean;
  signerAuthorized: boolean;
  submittedOn: Date;
  outputPdfFileName: string;
  status: SignatureStatus;
  updateLastViewed: boolean;
}
